import React, {Component} from 'react';
import ProgressiveImage from "react-progressive-image-loading";
import {sendBlogComment} from "../../store/actions/blogActions";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import AddBlogComment from "./AddBlogComment";
import {withTranslate} from "react-redux-multilingual";

class CommentCard extends Component {

    state = {
        fields: {},
        errors: {},
        comment_parent: 0,
        post_id: 0,
        replyToCommentID: null,
    };
    // update status on change
    handleInputChange = (e, field) => {
        let fields = this.state.fields;
        fields[field] = e.target.value;
        this.setState({fields});
    };

    // handle page comment submission
    onCommentSubmission(e) {
        this.props.onSubmission(e, this.state.replyToCommentID);
        this.setState({
            replyToCommentID: null,
        });
        // show comment form in single page
        this.props.handleShowCommentFormInSinglePage(true);
    }

    // handle show reply form recursively
    addReply(e, id) {
        e.preventDefault();
        this.setState({
            replyToCommentID: id
        });

        if (this.state.replyToCommentID !== null && this.state.replyToCommentID === id) {
            this.setState({
                replyToCommentID: null
            });

            // hide comment form in single page
            this.props.handleShowCommentFormInSinglePage(true);
        } else {
            this.props.handleShowCommentFormInSinglePage(false);
        }

    }


    render() {
        if (this.props.error500) {
            this.props.history.push("/maintenance")
        }
        return (
            <div>
                <ul className="comment-list">
                    <li className="comment">
                        <div className="vcard bio">
                            <ProgressiveImage
                                preview="/images/placeholder.png"
                                src="http://0.gravatar.com/avatar/9178ba0450fe60c56ff65cd0f5a67ce2?s=32&d=mm&r=g"
                                render={(src, style) => <img className="comment-classic-image" alt="" width="48"
                                                             height="48"
                                                             src={src} style={style}/>}
                            />
                        </div>
                        <div className="comment-body">
                            <h3>{this.props.comment.comment_author}</h3>
                            <div className="meta">{this.props.comment.comment_date}</div>
                            <p>{this.props.comment.comment_content}</p>
                            <p><a href="/" className="reply btn-style-less" aria-label="reply"
                                  onClick={(e) => this.addReply(e, this.props.comment.comment_ID)}
                                  hidden={this.props.index >= 4}>{this.props.translate("reply")}</a></p>
                        </div>
                        <div id="comment-reply"></div>
                    </li>
                </ul>
                <div className="post-comments comment-area clearfix"
                     hidden={this.state.replyToCommentID !== this.props.comment.comment_ID}>

                    <div className="add-comment-box">
                        <div className="add-comment-box" id="respond">
                            <div className="single-blog-title-box"><h2>{this.props.translate("leave_reply")}</h2>
                            </div>
                            <div className="default-form">
                                <AddBlogComment errors={this.props.errors} fields={this.props.fields}
                                                onSubmission={(e) => this.onCommentSubmission(e)}
                                                addingComment={this.props.addingComment}
                                                handleInputChange={(e, author) => this.props.handleInputChange(e, author)}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

};
const
    mapStateToProps = (state) => {
        return {
            currentPost: state.blog.currentPost,
            postComments: state.blog.postComments,
            postReplies: state.blog.postReplies,
            categories: state.blog.categories,
            tags: state.blog.tags,
            currentPostIsLoading: state.blog.currentPostIsLoading,
            objectNotFound: state.blog.objectNotFound,
            error500: state.global.error500,
        }
    };

const
    mapDispatchToProps = (dispatch) => {
        return {
            sendBlogComment: (data) => dispatch(sendBlogComment(data)),
        }
    };
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withTranslate(CommentCard)));

